<template>
  <div>
    <div class="menu_bg p1 acsb">
      <div class="ac">
        <div class="logo mr40" @click="select_menu(menus[0])">
          <!-- {{ get_logo() }} -->
          <img :src="logo" class="w80 p10 ml20" alt="" />
        </div>
        <el-menu :default-active="activeIndex2" mode="horizontal" background-color="#4073fa" text-color="#F2F6FC" active-text-color="#fff" class="fs22 fw600">
          <el-menu-item :index="String(index)" @click="change_top_menu(item)" v-for="(item, index) in top_menu" :key="index">
            {{ item.name }}
          </el-menu-item>
        </el-menu>
      </div>
      <div class="mr20 btn admin_info">
        <el-dropdown @command="handleCommand">
          <span style="color: #fff" class="fs16 fw600"> {{ adminName }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="clear_local_cache">更新本地缓存</el-dropdown-item> -->
            <!-- <el-dropdown-item command="admin_info">更新云端缓存</el-dropdown-item> -->
            <!-- <el-dropdown-item command="admin_info">个人资料</el-dropdown-item> -->
            <el-dropdown-item command="show_update_pwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout">退出登陆</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <!-- 修改密码的弹窗 -->
      <el-dialog title="修改密码" :visible.sync="show_update_pwd" width="40%" center @close="close_update_pwd" append-to-body>
        <div>
          <el-form label-position="left" label-width="100px">
            <el-form-item label="当前密码" required>
              <el-input v-model="update_data.old_password" placeholder="请输入内容" type="password"></el-input>
            </el-form-item>
            <el-form-item label="新的密码" required>
              <el-input v-model="update_data.new_password" placeholder="请输入内容" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" required>
              <el-input v-model="update_data.verify_password" placeholder="请输入内容" type="password"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close_update_pwd">取 消</el-button>
          <el-button type="primary" @click="update_pwd_func">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {http_post} from '@/api/api.js'

export default {
  data() {
    return {
      activeIndex2: '0',
      show_update_pwd: false,
      update_data: {},
      top_menu: [],
      logo: process.env.VUE_APP_BASE_API + '/api/admin/basics/sys/get_logo'
    }
  },
  created() {
    const now_path = this.$route.path
    const one = now_path.split('/')[1]
    this.top_menu = this.TopMenu
    this.TopMenu.forEach((item, index) => {
      if (item.path == '/' + one) {
        this.activeIndex2 = String(index)
      }
    })
  },

  computed: {
    adminName() {
      return localStorage.getItem('admin_name')
    },
    // 获取当前用户角色
    adminRole() {
      return localStorage.getItem('admin_role')
    },
    // 过滤顶部菜单 (一级菜单)
    TopMenu() {
      let menus = []
      this.$router.options.routes.forEach(route => {
        if (route.role_name && route.role_name.includes(this.adminRole)) {
          menus.push(route)
        }
      })
      return menus
    }
  },
  // watch: {
  //   '$route.query.time': function (newTime) {
  //     // 当 mcode 参数变化时，执行刷新或其他操作
  //     window.location.reload()
  //   }
  // },
  methods: {
    change_top_menu(item) {
      const path = item.path
      const timestamp = Date.now() // 取8位
      const query = {id: item.id, time: timestamp}
      document.title = item.name
      this.$router.push({path, query})
    },

    handleCommand(command) {
      if (command === 'logout') {
        localStorage.removeItem('tokena')
        localStorage.removeItem('topMenu')
        localStorage.removeItem('admin_role')
        localStorage.removeItem('admin_name')

        this.$router.replace({path: '/login'})
      } else if (command === 'show_update_pwd') {
        this.show_update_pwd = true
      } else if (command === 'admin_info') {
        this.$router.push('/admin/info')
      } else if (command == 'clear_local_cache') {
        // 清除本地缓存
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i)
          if (key !== 'tokena') {
            localStorage.removeItem(key)
          }
        }
        this.$message('清理成功')
        setTimeout(() => {
          window.location.reload() // 2秒后刷新页面
        }, 1500)
      }
    },
    close_update_pwd() {
      this.update_data = {}
      this.show_update_pwd = false
    },
    //修改密码
    update_pwd_func() {
      http_post('/api/admin/auth/update_password', this.update_data, 1).then(res => {
        if (res.code == 200) {
          this.close_update_pwd()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.menu_bg {
  color: #fff;
  background-color: rgb(64, 115, 250);
}
</style>

<style scoped>
.el-menu.el-menu--horizontal {
  border: none;
}

.el-icon-arrow-down:before {
  color: #fff;
}

.el-submenu__title i {
  color: #fff;
}

@media (max-width: 650px) {
  .logo {
    display: none;
  }
}
</style>
